export default __webpack_public_path__ + "static/smellsLikeRasberry-05184993f35c3634fe6c1281c57038ac.png";